import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class SessionLinkService {
  constructor(private readonly httpClient: HttpClient) {}

  getPackageUserGuidLink(PackageUserGuid: string): Observable<string> {
    return this.httpClient.get(`sessionLinks/${PackageUserGuid}`, {
      responseType: 'text',
    });
  }
}
